export const PLANS = [
  {
    id:       "free",
    name:     "Starter",
    price:    0,
    period:   "forever",
    badge:    null,
    color:    "#4a5e70",
    accent:   "#4ade80",
    features: [
      "1 active project",
      "Unlimited walls, rooms & openings",
      "Full BOQ & cost estimation",
      "Auto-heal graph engine",
      "PDF / print export",
      "Saved to this browser (localStorage)",
      "No sign-in required",
    ],
    cta:      "Start free",
    ctaLink:  "/app",
    highlight: false,
  },
  {
    id:       "pro",
    name:     "Pro",
    price:    499,
    period:   "month",
    annualPrice: 4499,   // ≈ 25% off
    badge:    "Most Popular",
    color:    "#3b82f6",
    accent:   "#60a5fa",
    features: [
      "Everything in Starter",
      "Unlimited projects",
      "Cloud sync across devices (Supabase)",
      "20-version snapshot history per project",
      "Share read-only link",
      "Priority support via email",
      "Export to DXF (coming soon)",
    ],
    cta:      "Start 14-day trial",
    ctaLink:  "/signup?plan=pro",
    highlight: true,
  },
  {
    id:       "team",
    name:     "Team",
    price:    1499,
    period:   "month",
    annualPrice: 13499,
    badge:    null,
    color:    "#a78bfa",
    accent:   "#c4b5fd",
    features: [
      "Everything in Pro",
      "Up to 10 team members",
      "Real-time collaboration (coming soon)",
      "Client portal — share live BOQ",
      "Custom material rate library",
      "White-label PDF reports",
      "Dedicated onboarding call",
    ],
    cta:      "Contact us",
    ctaLink:  "mailto:info@dplhomestar.com?subject=DPL Jade Team Plan",
    highlight: false,
  },
];

export const BILLING_NOTE =
  "Prices in INR, inclusive of GST where applicable. Annual plans billed as a single payment. Cancel anytime — no questions asked.";
